import React, {Component} from 'react';
import {
    Dialog,
    DialogContent,
    Icon,
    Button,
    IconButton,
    Typography,
    DialogActions,
    Toolbar,
    AppBar,
    FormControl,
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import {UecareInput} from '../../../../components';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxCompany from '../../../../store/actionreducers/company';
import {connect} from 'react-redux';
import _ from 'lodash';
import UecareUploadButton from "../../../../components/UecareUploadButton";
import {constDataDialogs} from "../../../../constants";

const initNewCompanyState = {
    name: '',
    email: '',
    no: '',
    member_bound: '',
    contract: undefined
};

class CompanyDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {company: initNewCompanyState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        /**
         * no companyDialog , no data need to resolve
         */
        if (!this.props.companyDialog) return;

        /**
         * After Dialog Open
         */
        if (!prevProps.companyDialog || (!prevProps.companyDialog.props.open && this.props.companyDialog.props.open)) {
            /**
             * Dialog type: 'edit'
             * Update State
             */
            const main_vip = this.props.company.main_vip;
            if (this.props.companyDialog.type === 'edit' &&
                this.props.company &&
                !_.isEqual(this.props.company, prevState.company)) {
                this.setState({company: {
                    ...this.props.company,
                        email: main_vip ? (main_vip.user ? main_vip.user.email : '?'): "",
                }});

            }

            /**
             * Dialog type: 'new'
             * Update State
             */
            if (this.props.companyDialog.type === 'new') {
                this.setState({company: initNewCompanyState});
            }
        }

    }

    handleChange(event) {
        const newCompany = {...this.state.company, [event.target.name]: event.target.value};
        this.setState({company: newCompany});
    }

    downloadFile(base64File) {
        window.open(base64File, "_blank");
    }

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.companyDialog});
    };

    canBeSubmitted() {
        const {name, email, no, member_bound} = this.state.company;
        if (parseInt(member_bound, 10) < 50) return false;
        return (name && name.length > 0
            && email && email.length > 0
            && no && no.length > 0);
    }

    render() {
        const {classes, companyDialog} = this.props;
        const {addCompany, getCompanies, updateCompany, deleteCompany, openLoadingMask, closeLoadingMask} = this.props;
        const groups = this.state.company.groups || [];

        if (!companyDialog || companyDialog.props.open === false) return <div/>;

        return (
            <Dialog className={classes.root} {...companyDialog.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            {companyDialog.type === 'new' ? '新的公司資料' : '公司資料'}
                        </Typography>
                    </Toolbar>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                    <UecareInput
                        label='名稱'
                        icon='account_circle'
                        name='name'
                        id='name'
                        className={classes.formControl}
                        value={this.state.company.name || ''}
                        onChange={this.handleChange.bind(this)}/>

                    <UecareInput
                        label='企業聯絡人信箱'
                        icon='mail'
                        name='email'
                        id='email'
                        inputType="email"
                        className={classes.formControl}
                        value={this.state.company.email || ''}
                        onChange={this.handleChange.bind(this)}/>
                    <UecareInput
                        label='會員上限'
                        icon='group'
                        name='member_bound'
                        id='member_bound'
                        inputType="number"
                        className={classes.formControl}
                        value={this.state.company.member_bound || ''}
                        onChange={this.handleChange.bind(this)}/>
                    {
                        companyDialog.type === 'new' ?
                            <UecareInput
                                label='統一編號'
                                name='no'
                                icon='card_membership'
                                id='no'
                                inputType="number"
                                className={classes.formControl}
                                value={this.state.company.no || ''}
                                onChange={this.handleChange.bind(this)}/>
                            :
                            <UecareInput
                                label='統一編號'
                                name='no'
                                icon='card_membership'
                                id='no'
                                disabled
                                className={classes.formControl}
                                value={this.state.company.no || ''}
                                onChange={this.handleChange.bind(this)}/>
                    }

                    <UecareUploadButton
                        label='上傳合約'
                        icon='picture_as_pdf'
                        name='contract'
                        id='contract'
                        variant="raised"
                        color="secondary"
                        value={this.state.company.contract || ''}
                        onClick={(base64File) => {
                            this.handleChange({target: {name: 'contract', value: base64File}});
                        }}/>

                    {
                        (this.state.company.contract) ?
                            <div className="flex">
                                <div className="min-w-48 pt-20"/>
                                <FormControl fullWidth>
                                    <Button id='download_contract'
                                            name='download_contract'
                                            className={classes.button}
                                            variant="raised"
                                            color="default"
                                            value={this.state.company.contract || ''}
                                            onClick={() => {
                                                this.downloadFile(this.state.company.contract);
                                            }}>
                                        下載合約
                                    </Button>
                                </FormControl>
                            </div>
                            :
                            <div/>
                    }

                </DialogContent>

                {
                    companyDialog.type === 'new' ?
                        (
                            <DialogActions className="justify-between pl-16">
                                <Button
                                    variant="raised"
                                    color="primary"
                                    disabled={!this.canBeSubmitted()}
                                    onClick={async () => {
                                        try {
                                            openLoadingMask();
                                            await addCompany(this.state.company, this.state.company.email);
                                            await getCompanies();
                                            closeLoadingMask();
                                            this.closeDataDialog();
                                        } catch (e) {
                                            console.warn('you got an error = ', e);
                                        }
                                    }}
                                >
                                    新增
                                </Button>
                            </DialogActions>
                        )
                        : (
                            <DialogActions className="justify-between pl-16">
                                <Button
                                    variant="raised"
                                    color="primary"
                                    disabled={!this.canBeSubmitted()}
                                    onClick={async () => {
                                        try {
                                            openLoadingMask();
                                            await updateCompany(this.state.company);
                                            await getCompanies();
                                            closeLoadingMask();
                                            this.closeDataDialog();
                                        } catch (e) {
                                            console.warn('you got an error = ', e);
                                        }
                                    }}
                                >
                                    修改
                                </Button>

                                {
                                    (groups.length > 0) ?
                                        <div/>
                                        :
                                        <IconButton
                                            onClick={async () => {
                                                try {
                                                    openLoadingMask();
                                                    await deleteCompany(this.state.company.id);
                                                    await getCompanies();
                                                    closeLoadingMask();
                                                    this.closeDataDialog();
                                                } catch (e) {
                                                    console.warn('you got an error = ', e);
                                                }
                                            }}
                                        >
                                            <Icon>delete</Icon>
                                        </IconButton>
                                }
                            </DialogActions>
                        )
                }

            </Dialog>
        );
    }
}

const styles = theme => ({
    root: {},
    button: {
        marginTop: theme.spacing.unit * 2,
    },
    formControl: {
        marginBottom: 24
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addCompany: ReduxCompany.ActionCreator.addCompany,
        getCompanies: ReduxCompany.ActionCreator.getCompanies,
        updateCompany: ReduxCompany.ActionCreator.updateCompany,
        deleteCompany: ReduxCompany.ActionCreator.deleteCompany,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({global: {dataDialogs}, company: {companies, company}}) {

    return {
        companyDialog: dataDialogs[constDataDialogs.name.companyDialog],
        company,
        companies
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(CompanyDialog));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/company/CompanyDialog.js